var _this = this;

/**
 * @file CapSmartResize
 * @module Capitan/es6/CapSmartResize
 * @copyright Brandung GmbH & Co KG
 * @author Sebastian Steiner
 * @version 2.0
 * @license MIT License (MIT)
 * @date 21.01.2018
 *
 */

/**
 * Method to debounce a given function on resize
 *
 * @param {function} func - function to be called
 * @param {number} [threshold=100] - wait time before executing the function
 * @param {bool} [execAsap=true] - execute function directly on resize or after
 * @param {object} [context=tthis] - can set different context if needed
 * @param {any} args - arguments for function
 */
var CapSmartResize = function CapSmartResize(func) {
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var execAsap = arguments.length > 2 ? arguments[2] : undefined;
  var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _this;

  for (var _len = arguments.length, args = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
    args[_key - 4] = arguments[_key];
  }

  var timeout = null;

  var debounced = function debounced() {
    if (timeout) {
      clearTimeout(timeout);
    } else if (execAsap) {
      func.apply(context, args);
    }

    timeout = setTimeout(function () {
      !execAsap && func.apply(context, args);
      timeout = null;
    }, threshold);
  };

  window.addEventListener('resize', debounced);
};

export default CapSmartResize;